import { IcoFeedbackWarning } from "assets/icons";
import colors from "colors";
import { Button, Modal, ModalFooter } from "components";

interface BackofficeConfirmCancelModalProps {
	isOpen: boolean;
	isLoading: boolean;
	applicationProcessCode: string;
	onClose: () => void;
	onConfirm: () => void;
}

export function BackofficeConfirmCancelModal({
	isOpen,
	isLoading,
	applicationProcessCode,
	onClose,
	onConfirm
}: Readonly<BackofficeConfirmCancelModalProps>) {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			contentClassName="rounded-lg md:max-w-md"
			bodyClassName="p-8"
		>
			<div className="flex flex-col items-start text-start gap-4">
				<IcoFeedbackWarning size="48" color={colors["feedback-alert"].alerts} />
				<h1 className="text-2xl font-semibold">Deseja continuar?</h1>
				<p className="text-neutral-low-400">
					Ao continuar, a solicitação {applicationProcessCode} será arquivada no
					sistema, seu status passa para cancelado e não será possível realizar
					nenhum novo registro.
				</p>
			</div>
			<ModalFooter>
				<Button
					hierarchy="primary"
					className="bg-feedback-negative-pure-500 border-feedback-negative-pure-500 w-full"
					onClick={onConfirm}
					isLoading={isLoading}
				>
					Confirmar cancelamento
				</Button>
				<Button
					hierarchy="secondary"
					className="w-full"
					onClick={onClose}
					disabled={isLoading}
				>
					Voltar
				</Button>
			</ModalFooter>
		</Modal>
	);
}
